import { useMemo } from 'react';
import { useChannelFilters } from '../../hooks/useChannelFilters';
import { FilterTag } from './ActiveFilterTags';

/**
 * Hook that returns active filter tags for channel filters.
 * Provides tag objects compatible with the ActiveFilterTags component.
 */
export function useChannelFilterTags(): FilterTag[] {
  const { filters, setSearch } = useChannelFilters();

  return useMemo(() => {
    const tags: FilterTag[] = [];

    if (filters.search) {
      tags.push({
        key: 'search',
        label: `Name: ${filters.search}`,
        onRemove: () => setSearch(''),
      });
    }

    return tags;
  }, [filters.search, setSearch]);
}


